import React, { useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "../../images/site_logo/site_logo_1.svg";
import "../../../src/constant.js";
import DefaultAvatar from "../../images/shapes/profile-icon-color 3.png";
import {
  FaEdit,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaWallet,
  FaHeadset,
  FaCog,
} from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import md5 from "md5";
import { API_URL } from "../../../src/constant.js";

const LoginHeaderR = () => {
  const [mobileActive, setMobileState] = useState(false);
  const [isSticky, setSticky] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [userData, setUserData] = useState(null);

  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 80);
    };

    const token = localStorage.getItem("auth_token");
    if (token) {
      setIsLoggedIn(true);
      fetchUserData();
    }

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isLoggedIn]);

  const fetchUserData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/me`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });
      const data = await response.json();
      setUserData(data.user);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const getUserAvatar = () => {
    if (userData?.avatar) return userData.avatar;
    if (userData?.email) {
      // Fallback to Gravatar if no avatar is provided
      const emailHash = md5(userData.email.trim().toLowerCase());
      return `https://www.gravatar.com/avatar/${emailHash}?d=identicon`;
    }
    return DefaultAvatar;
  };

  const ClickHandler = () => {
    window.scrollTo(10, 0);
    setMobileState(false);
  };

  const confirmLogout = async () => {
    try {
      const response = await fetch(`${API_URL}/api/retail-business/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("auth_token")}`,
        },
      });

      if (response.ok) {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
        setIsLoggedIn(false);
        navigate("/work-with-tcuk");
        setShowLogoutConfirm(false);
        setMobileState(false);
        window.location.reload();
      } else {
        console.error("Failed to logout");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  const headerRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setMobileState(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <header
      className={`site_header ${isSticky ? "sticky" : ""}`}
      ref={headerRef}
    >
      <div className="nav_wrapper">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-3 col-6 d-flex align-items-center">
              <div className="site_logo">
                <NavLink
                  className="site_link"
                  to="/retail-business/wallet"
                  onClick={ClickHandler}
                >
                  <img loading="lazy" src={Logo} alt="TopCoin Uk" />
                </NavLink>
              </div>
            </div>

            <div className="col-lg-6 d-none d-lg-block">
              <nav className="main_menu navbar navbar-expand-lg">
                <div
                  className={`main_menu_inner collapse navbar-collapse justify-content-center ${
                    mobileActive ? "show" : ""
                  }`}
                  id="main_menu_dropdown"
                >
                  <ul className="main_menu_list unordered_list text-uppercase main-menu">
                    <li>
                      <NavLink
                        to="/retail-business/wallet"
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                        style={{ color: "#fff" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="Wallet"
                          style={{ color: "#fff" }}
                        >
                          Wallet
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/privacy-policy-r"
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                        style={{ color: "#fff" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="Privacy Policy"
                          style={{ color: "#fff" }}
                        >
                          Privacy Policy
                        </span>
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/terms-conditions-r"
                        className="nav-link scrollspy_btn"
                        onClick={ClickHandler}
                        style={{ color: "#fff" }}
                      >
                        <span
                          className="nav_link_label"
                          data-text="Terms & Conditions"
                          style={{ color: "#fff" }}
                        >
                          Terms & Conditions
                        </span>
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            <div className="col-lg-3 col-6">
              <ul className="btns_group unordered_list p-0 justify-content-end">
                <li className="d-lg-none">
                  <button
                    className="mobile_menu_btn"
                    type="button"
                    onClick={() => setMobileState(!mobileActive)}
                    style={{
                      background: "transparent",
                      border: "none",
                      fontSize: "24px",
                      color: "#fff",
                      transition: "transform 0.3s ease",
                    }}
                  >
                    {mobileActive ? (
                      <IoMdClose style={{ fontSize: "28px" }} />
                    ) : (
                      <FaBars />
                    )}
                  </button>
                </li>

                <li
                  className="d-none d-lg-block"
                  style={{ position: "relative" }}
                  ref={dropdownRef}
                >
                  {isLoggedIn ? (
                    <>
                      <button
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        className="d-flex align-items-center gap-2"
                        style={{
                          backgroundColor: "#fff",
                          color: "#003087",
                          borderRadius: "12px",
                          padding: "8px 12px",
                          border: "none",
                          fontWeight: "bold",
                        }}
                      >
                        {/* <img
                          src={getUserAvatar()}
                          alt="avatar"
                          style={{ width: 24, height: 24, borderRadius: "50%" }}
                        /> */}
                        {userData?.email || "Profile"} ▾
                      </button>

                      {dropdownOpen && (
                        <div
                          className="position-absolute"
                          style={{
                            right: 0,
                            top: "calc(100% + 8px)",
                            width: "200px",
                            backgroundColor: "#fff",
                            border: "1px solid #eee",
                            borderRadius: "12px",
                            boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.1)",
                            zIndex: 9999,
                          }}
                        >
                          <NavLink
                            to=""
                            onClick={() => {
                              setDropdownOpen(false);
                              setMobileState(false);
                            }}
                            className="d-flex align-items-center px-4 py-3"
                            style={{
                              color: "#003087",
                              fontWeight: 500,
                              textDecoration: "none",
                              gap: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <FaEdit /> Edit Profile
                          </NavLink>
                          <button
                            onClick={() => {
                              setShowLogoutConfirm(true);
                              setDropdownOpen(false);
                            }}
                            className="d-flex align-items-center px-4 py-3 w-100"
                            style={{
                              color: "#003087",
                              fontWeight: 400,
                              background: "transparent",
                              border: "none",
                              gap: "8px",
                              cursor: "pointer",
                              textAlign: "left",
                            }}
                          >
                            <FaSignOutAlt /> Logout
                          </button>
                        </div>
                      )}
                    </>
                  ) : (
                    <NavLink
                      onClick={ClickHandler}
                      className="ico_btn_outline"
                      to="/work-with-tcuk"
                      style={{
                        backgroundColor: "#fff",
                        color: "#003087",
                        padding: "8px 16px",
                        borderRadius: "12px",
                        fontWeight: "bold",
                        border: "none",
                      }}
                    >
                      Join Now
                    </NavLink>
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Mobile Menu */}
      <div className={`mobile-menu-wrapper ${mobileActive ? "active" : ""}`}>
        <div className="mobile-menu-container">
          <div className="mobile-menu-header">
            <div
              className="mobile-menu-close"
              onClick={() => setMobileState(false)}
            >
              <IoMdClose size={28} />
            </div>

            {isLoggedIn ? (
              <div className="mobile-profile-card">
                <div className="profile-info">
                  {/* <img
                    src={getUserAvatar()}
                    alt="avatar"
                    className="profile-avatar"
                  /> */}
                  <div className="profile-text">
                    <h4>{userData?.name || "My Account"}</h4>
                    {userData?.email && <p>{userData.email}</p>}
                  </div>
                </div>
                <div className="profile-actions">
                  <NavLink
                    to=""
                    onClick={ClickHandler}
                    className="mobile-nav-link2"
                  >
                    <FaEdit className="action-icon " />
                    <span>Edit Profile</span>
                  </NavLink>
                  <button
                    onClick={() => setShowLogoutConfirm(true)}
                    className="profile-action-btn"
                  >
                    <FaSignOutAlt className="action-icon" />
                    <span>Logout</span>
                  </button>
                </div>
              </div>
            ) : (
              <div className="mobile-join-section">
                <h3>Join TopCoin Today</h3>
                <p>Access your wallet and start trading</p>
                <NavLink
                  onClick={ClickHandler}
                  className="mobile-join-btn"
                  to="/login#google-login-button"
                >
                  Sign In / Register
                </NavLink>
              </div>
            )}
          </div>

          <nav className="mobile-nav">
            <ul className="mobile-nav-list">
              <li>
                <NavLink
                  to="/retail-business/wallet"
                  onClick={ClickHandler}
                  className="mobile-nav-link"
                >
                  <FaWallet className="nav-icon" />
                  <span>Wallet</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/privacy-policy-r"
                  onClick={ClickHandler}
                  className="mobile-nav-link"
                >
                  <FaHeadset className="nav-icon" />
                  <span>Privacy Policy</span>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/terms-conditions-r"
                  onClick={ClickHandler}
                  className="mobile-nav-link"
                >
                  <FaCog className="nav-icon" />
                  <span>Terms & Conditions</span>
                </NavLink>
              </li>
            </ul>
          </nav>

          <div className="mobile-footer">
            <p>© {new Date().getFullYear()} TopCoin UK</p>
          </div>
        </div>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="logout-confirmation-modal">
          <div className="modal-content">
            <h5>Logout Confirmation</h5>
            <p>Are you sure you want to logout?</p>
            <div className="modal-actions">
              <button onClick={confirmLogout} className="confirm-btn">
                Confirm
              </button>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        /* Mobile Menu Wrapper */
        .mobile-menu-wrapper {
          position: fixed;
          top: 0;
          right: -100%;
          width: 85%;
          max-width: 350px;
          height: 100vh;
          background: linear-gradient(135deg, #003087 0%, #001a4d 100%);
          box-shadow: -5px 0 15px rgba(0, 0, 0, 0.1);
          z-index: 9998;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          overflow-y: auto;
        }

        /* Sticky header styles */
        .site_header.sticky {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 999;
          background: #001964;
          backdrop-filter: blur(5px);
          animation: slideDown 0.3s ease-out;
        }

        .mobile-menu-wrapper.active {
          right: 0;
          width: 80%;
        }

        /* Mobile Menu Container */
        .mobile-menu-container {
          padding: 20px;
          height: 100%;
          display: flex;
          flex-direction: column;
        }

        /* Header Section */
        .mobile-menu-header {
          margin-bottom: 30px;
        }

        .mobile-menu-close {
          text-align: right;
          margin-bottom: 20px;
          color: #fff;
          cursor: pointer;
        }

        /* Profile Card */
        .mobile-profile-card {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 30px;
          backdrop-filter: blur(5px);
        }

        .profile-info {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 20px;
        }

        .profile-avatar {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 2px solid #fff;
        }

        .profile-text {
          color: #fff;
          margin: 0;
          font-size: 18px;
        }

        h4 {
          color: #fff;
          margin: 0;
          font-size: 16px;
        }

        .profile-text p {
          color: rgba(255, 255, 255, 0.7);
          margin: 5px 0 0;
          font-size: 14px;
        }

        .profile-actions {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .profile-action-btn {
          display: flex;
          align-items: center;
          gap: 12px;
          background: transparent;
          border: none;
          color: #fff;
          padding: 10px;
          border-radius: 8px;
          transition: all 0.3s ease;
          text-decoration: none;
        }

        .profile-action-btn:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .action-icon {
          font-size: 18px;
        }

        /* Join Section */
        .mobile-join-section {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 12px;
          padding: 20px;
          margin-bottom: 30px;
          text-align: center;
          backdrop-filter: blur(5px);
        }

        .mobile-join-section h3 {
          color: #fff;
          margin: 0 0 10px;
          font-size: 18px;
        }

        .mobile-join-section p {
          color: rgba(255, 255, 255, 0.7);
          margin: 0 0 15px;
          font-size: 14px;
        }

        .mobile-join-btn {
          display: inline-block;
          background: #fff;
          color: #003087;
          padding: 12px 20px;
          border-radius: 8px;
          font-weight: bold;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .mobile-join-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        /* Navigation */
        .mobile-nav-list {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .mobile-nav-list li {
          margin-bottom: 5px;
        }

        .mobile-nav-link {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 15px;
          color: #fff;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .mobile-nav-link2 {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 10px;
          color: #fff;
          text-decoration: none;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .mobile-nav-link:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .mobile-nav-link2:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .nav-icon {
          font-size: 20px;
          width: 24px;
          text-align: center;
        }

        /* Footer */
        .mobile-footer {
          margin-top: auto;
          padding-top: 20px;
          text-align: center;
          color: rgba(255, 255, 255, 0.5);
          font-size: 12px;
        }
          /* Logout Confirmation Modal */
        .logout-confirmation-modal {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 99999;
        }

        .modal-content {
          background: #fff;
          padding: 30px;
          border-radius: 20px;
          width: 90%;
          max-width: 320px;
          text-align: center;
          box-shadow: 0 5px 25px rgba(0, 0, 0, 0.2);
        }

        .modal-content h5 {
          color: #003087;
          font-weight: bold;
          margin-bottom: 10px;
        }

        .modal-content p {
          color: #666;
        }

        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          gap: 10px;
        }

        .confirm-btn {
          background: #003087;
          color: #fff;
          padding: 10px 20px;
          border-radius: 12px;
          border: none;
          font-weight: bold;
          flex: 1;
          cursor: pointer;
        }

        .cancel-btn {
          border: 1px solid #003087;
          color: #003087;
          padding: 10px 20px;
          border-radius: 12px;
          background: #fff;
          font-weight: bold;
          flex: 1;
          cursor: pointer;
        }
      `}</style>
    </header>
  );
};

export default LoginHeaderR;
